import script from "./TressTheSignIn.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressTheSignIn.vue?vue&type=script&lang=ts&setup=true"

import "./TressTheSignIn.vue?vue&type=style&index=0&id=aa6400b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa6400b2"]])

export default __exports__